import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {Dialog} from "@blueprintjs/core";
import {DoiTuongKienNghiView} from 'modules/theo-doi-thuc-hien/sub-view';
import { ShowIf } from 'components/utils';
import moment from 'moment';

class RowItemDoiTuongThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false
    }
  }

  handleEdit() {
    this.props.handleEdit(this.props.item.doiTuongViPhamId);
  }

  closeDialog() {
    this.setState({
      isOpen: false
    })
  }

  handleView() {
    this.setState({
      isOpen: true
    })
  }

  getThoiHan() {
    let thoiHanXuLy = this.props.item.tinhTrangThoiHanInfo;
    if (thoiHanXuLy.type == 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <span className='txt-bold' style={{ color: "#E9573F" }}>Đã hết hạn</span>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <span>Còn {thoiHanXuLy.value} ngày</span>
        )
      } else {
        return (
          <span className='txt-bold' style={{ color: "#E9573F" }}>Đã hết hạn</span>
        )
      }
    } else if (thoiHanXuLy.type == 'TIME') {
      return (
        <span className='txt-bold' style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</span>
      )
    }
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.ten ? this.props.item.ten : ''}</td>
        <td>{this.props.item.linhVucKetQuaThanhTra.ten ? this.props.item.linhVucKetQuaThanhTra.ten : ''}</td>
        <td>
          <ShowIf condition={this.props.item.tienDo != 'HOAN_THANH'}>
            <p>{this.props.item.ngayHetHanTheoTienDo ? moment(this.props.item.ngayHetHanTheoTienDo).format('DD/MM/YYYY') : ''}({this.getThoiHan()})</p>
          </ShowIf>
        </td>
        <td>{this.props.item.tienDoInfo ? this.props.item.tienDoInfo.text : ''}</td>
        <td>
          <ShowIf condition={this.props.item.tienDo != 'HOAN_THANH' && this.props.view != true}>
            <div className="todo-wrap two-item">
              <div className="wrap-link-todo">
                <Link className="itt-redirect" onClick={this.handleEdit.bind(this)}>Xử lý</Link>
              </div>
              <ShowIf condition={this.props.enableDelete == true}>
                <DeleteDialog
                  title={'Xác nhận'}
                  content={`Bạn có đồng ý xóa đối tượng vi phạm này không?`}
                  redux={this.props.parent}
                  deleteId={this.props.item.doiTuongViPhamId}
                />
              </ShowIf>
            </div>
          </ShowIf>
          <ShowIf condition={this.props.item.tienDo == 'HOAN_THANH' || this.props.view == true}>
            <div className="todo-wrap two-item">
              <div className="wrap-link-todo">
                <Link className="text-13 txt-blue" onClick={this.handleView.bind(this)}>Xem chi tiết</Link>
              </div>
              <Dialog
                isOpen={this.state.isOpen}
                onClose={this.closeDialog.bind(this)}
                title={`Chi tiết đối tượng ${this.props.item.ten ? this.props.item.ten : ''}`}
                className="dialog-default wrap-block">
                  <DoiTuongKienNghiView toChucLienQuan={this.props.toChucLienQuan} data={this.props.item} type={this.props.type} closeDialog={this.closeDialog.bind(this)} chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} linhVucThanhTra={this.props.linhVucThanhTra}/>
              </Dialog>
            </div>
          </ShowIf>
        </td>
      </tr>
    );
  }
}

RowItemDoiTuongThanhTra.defaultProps = {
  handleEdit: function() {
    console.log('Need append handleEdit menthod');
  },
  enableDelete: false
}

export default RowItemDoiTuongThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/datatable/RowItemDoiTuongThanhTra.jsx